import styled from 'styled-components';

export const WarrantyEmptyIcon = styled.div`
  height: 112px;
  width: 112px;
`;

export const ProgressTrackerWrapper = styled.div`
  -ms-grid-column: 1;
  -ms-grid-row: 1;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  padding: 0;
  margin: 0 0 24px 0;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    -ms-grid-column: 1;
    -ms-grid-row: 1;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    margin: auto auto;
  }
`;

export const ProgressEndDate = styled.div`
  font-weight: 700;
  text-transform: uppercase;
  color: var(--cvna-color-grey-5);
`;

export const EndDateText = styled.p`
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  margin-bottom: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Date = styled.h3`
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-size: 50px;
    line-height: 50px;
  }
`;

export const CompletedText = styled.h3`
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  margin-bottom: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-align: left;
    font-size: 12px;
    line-height: 18px;
  }
`;